"use strict";

exports.__esModule = true;
exports.PlantGridWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _PlantGridElement = require("./PlantGridElement");
var _PlantGridFields = require("./PlantGridFields");
var _PlantGridHeader = require("./PlantGridHeader");
var _PlantGridThumbnail = require("./PlantGridThumbnail");
var _widgetGroups = require("../widgetGroups");
var _EditablePlantGridElement = require("./EditablePlantGridElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PlantGridWidget = exports.PlantGridWidget = {
  name: "PlantGrid",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "PlantGridWidget.label",
    defaultMessage: "Plant Grid"
  }),
  icon: "layout-grid",
  group: _widgetGroups.LAYOUT_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "PlantGrid",
      props: Object.assign({
        width: 800,
        height: 600,
        itemHeight: 300,
        itemWidth: 300,
        dataRange: ""
      }, props),
      children: [{
        type: "Grid",
        props: {
          rowCount: 12,
          columnCount: 12,
          position: "absolute"
        },
        children: []
      }]
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["rowGutter", "columnGutter", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "itemWidth", "itemHeight"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 800,
      min: 256,
      max: 3840
    },
    height: {
      "default": 600,
      min: 256,
      max: 2160
    },
    itemWidth: {
      "default": 300,
      min: 128,
      max: function max(props) {
        return props.width;
      }
    },
    itemHeight: {
      "default": 300,
      min: 64,
      max: function max(props) {
        return props.height;
      }
    }
  },
  components: {
    Header: _PlantGridHeader.PlantGridHeader,
    Element: _PlantGridElement.PlantGridElement,
    Fields: _PlantGridFields.PlantGridFields,
    Thumbnail: _PlantGridThumbnail.PlantGridThumbnail,
    Editable: _EditablePlantGridElement.EditablePlantGridElement
  }
};